import React from 'react';
import ReportingMembershipsEngagementPage from '../components/ReportingMembershipsEngagementPage';

const ReportingMembershipsEngagementApp = (props) => (
  <ReportingMembershipsEngagementPage {...props} />
);

export default ReportingMembershipsEngagementApp;
